// @flow
import React from 'react';

export default ({ className }: { className: string }) => (
  <svg viewBox="0 0 31 36" className={className}>
    <g fill="none" fillRule="evenodd" transform="translate(1 1)">
      <g fill="#fff">
        <path
          d="m0 0h10.5729167l6.34375 13.3571429h-10.5729167z"
          stroke="#9556b7"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="m29 0h-10.5729167l-6.34375 13.3571429h10.5729167z"
          stroke="#9556b7"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path d="m26.5833333 21.25c0 7.04208-5.67994 12.75-12.6875 12.75-7.00755997 0-12.68749997-5.70792-12.68749997-12.75s5.67994-12.75 12.68749997-12.75c7.00756 0 12.6875 5.70792 12.6875 12.75" />
      </g>
      <path
        d="m27 21.5c0 6.904-5.596 12.5-12.5 12.5s-12.5-5.596-12.5-12.5 5.596-12.5 12.5-12.5 12.5 5.596 12.5 12.5z"
        fill="#efe5f4"
        stroke="#9556b7"
        strokeWidth="2"
      />
      <path
        d="m20.9625907 18.4606385c-.0715587-.1698468-.2347874-.2797195-.4153212-.2797195l-3.8300283-.0086363-1.7515517-3.9007197c-.0738972-.1650489-.2352551-.271563-.4120472-.271563h-.0042094c-.1791306.0014394-.3395531.1108323-.4115795.2787599l-1.6729774 3.8935228-4.01243295.0086363c-.18287228 0-.3475041.1132312-.41765971.2869164-.0701556.1727256-.03227158.3723196.09634703.5052224l3.14063263 3.2510795-.9461653 4.2058682c-.0406902.1818417.0280623.3713601.1749213.4807529.0795097.0590146.1730505.0892416.2670591.0892416.0799773 0 .1608901-.0215907.2329166-.0662115l3.5554861-2.1849788 3.645753 2.1873778c.1552777.0930799.3498426.083484.4948309-.0254291.1454559-.1074737.2151438-.2941133.1767921-.4749953l-.9045396-4.266802 2.9095868-3.205979c.1230062-.1353017.1557454-.3324968.0841867-.5023436"
        fill="#9556b7"
      />
    </g>
  </svg>
);
